'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var React = require('react');
var clsx = require('clsx');
var bumbag = require('bumbag');
var components_ErrorMessage = require('./components/ErrorMessage.js');
require('@babel/runtime/helpers/defineProperty');
require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
require('lodash/get');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["isActive", "children", "className", "description", "error"];

var WithErrorMessage = function WithErrorMessage(_ref) {
  var _clsx;

  var isActive = _ref.isActive,
      children = _ref.children,
      className = _ref.className,
      description = _ref.description,
      error = _ref.error,
      props = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, props, isActive ? /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    className: clsx.clsx((_clsx = {}, _clsx[className || ''] = Boolean(className), _clsx)),
    "data-testid": "error"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Alert, {
    title: "Error",
    hasIcon: true,
    type: "danger",
    variant: "tint"
  }, /*#__PURE__*/React__default["default"].createElement(components_ErrorMessage["default"], {
    description: description,
    err: error
  }))) : children);
};

WithErrorMessage.defaultProps = {
  children: null,
  className: null,
  description: 'Something wrong happened.',
  error: null
};

exports["default"] = WithErrorMessage;
